import React, { useState, useEffect } from 'react';

const DaySelect = () => {
    // 현재 날짜에 해당하는 일 선택
    const getCurrentDay = () => {
        return new Date().getDate();
    };

    // 선택된 월의 마지막 날짜를 계산하는 함수
    const getLastDayOfMonth = (year, month) => {
        return new Date(year, month + 1, 0).getDate();
    };

    // 선택된 월의 1일부터 마지막 일까지 자동 생성
    const getCurrentMonthDays = () => {
        const currentMonth = new Date().getMonth();
        const lastDay = getLastDayOfMonth(new Date().getFullYear(), currentMonth);
        const days = [];
        for (let day = 1; day <= lastDay; day++) {
            days.push({ value: day.toString(), label: day.toString() });
        }
        return days;
    };

    const [selectedDay, setSelectedDay] = useState(getCurrentDay().toString());
    const dayValue = getCurrentMonthDays();

    const handleChange = (event) => {
        setSelectedDay(event.target.value);
    };

    

    return (
        <select
            value={selectedDay}
            onChange={handleChange}
            style={{ width: '100%', padding: '0.5rem' }}
        >
            {dayValue.map((day) => (
                <option key={day.value} value={day.value}>{day.label}</option>
            ))}
        </select>
    );
};

export default DaySelect;